// extracted by mini-css-extract-plugin
module.exports = {"jobCardCol":"JobCard_jobCardCol__lJDzu","jobCard":"JobCard_jobCard__0_VLi"};